import VueI18n from '../i18n.js'
import api from '../connectors/Api'

const $t = VueI18n.t.bind(VueI18n)
const API = api()

export default {
  namespaced: true,
  state: {
    defaultConfig: {}
  },
  mutations: {
    setDefaultConfig (state, config) {
      state.defaultConfig = config
    }
  },
  getters: {
    translate: (state) => (key) => {
      return $t(`view-Settings.notification.key.${key}`)
    },
    optionList: (state) => (usersType) => {
      const config = state.defaultConfig[usersType]
      let optionList = []
      for (const i in config) {
        /* remove _sms and _email */
        optionList.push(i.split('_').filter(sp => sp !== 'sms' && sp !== 'email').join('_'))
      }
      /* remove duplicate */
      optionList = [...new Set(optionList)]

      return optionList
    }
  },
  actions: {
    load ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getDefaultNotificationsConfig(token)
            .then((res) => {
              commit('setDefaultConfig', res.body)
              resolve(state.defaultConfig)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
